/**
 * Prevent Auto-Submission on Focus
 * Satisfies WCAG 3.2.1 (On Focus) and 3.2.2 (On Input)
 */
(function() {
  let userTriggered = false;

  // Track explicit user actions that are allowed to trigger a submission
  const recordUserAction = (e) => {
    // If it's a click or an Enter/Space keypress on a submit element
    if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
      userTriggered = true;
      // Reset after a short delay to allow the submit event to fire
      setTimeout(() => { userTriggered = false; }, 100);
    }
  };

  // Intercept all submit events on the page
  document.addEventListener('submit', function(event) {
    // If the event is generated by a real user action (click/enter), allow it
    if (event.isTrusted) {
      return; 
    }

    // If the submission is programmatic (event.isTrusted is false)
    // we block it unless we recently recorded a manual user action
    if (!userTriggered) {
      console.warn('ADA: Blocked an automatic form submission on focus/input.', event.target);
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);

  // Attach listeners to all buttons and inputs that could trigger a submit
  function attachListeners() {
    const triggers = document.querySelectorAll('button, input[type="submit"], input[type="checkbox"], input[type="radio"], select');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', recordUserAction);
      trigger.addEventListener('keydown', recordUserAction);
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

  // Also watch for dynamically added forms/inputs (common in Shopify apps)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) attachListeners();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();